import {} from './';
import {
  CANCEL_IMAGE_PREVIEW,
  DEFAULT_BRIGHTNESS,
  DEFAULT_IMAGE_CROP,
  SAVE_IMAGE,
  SAVE_IMAGE_SUCCESS,
  UPDATE_BRIGHTNESS,
  UPDATE_CROPPING,
  UPDATE_CROP_SCALE,
  UPDATE_CROP_TOOL_PROPS,
  UPDATE_IMAGE_CROP,
  UPDATE_IMAGE_PROPS,
  UPDATE_KEEP_ASPECT_RATIO,
  UPDATE_PREVIEWING,
  UPDATE_SAVING,
  UPDATE_STAGE_PROPS,
  UPDATE_WAS_CROPPING,
  VIEW_IMAGE_PREVIEW,
} from './constants';

export const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE_PREVIEWING:
      return {
        ...state,
        previewing: action.value,
      };
    case UPDATE_CROPPING:
      return {
        ...state,
        cropping: action.value,
      };
    case UPDATE_WAS_CROPPING:
      return {
        ...state,
        wasCropping: action.value,
      };
    case UPDATE_SAVING:
      return {
        ...state,
        saving: action.value,
      };
    case UPDATE_BRIGHTNESS:
      return {
        ...state,
        brightness: action.value,
      };
    case UPDATE_IMAGE_CROP:
      return {
        ...state,
        imageCrop: action.value,
      };
    case UPDATE_STAGE_PROPS:
      return {
        ...state,
        stageProps: action.props,
      };
    case UPDATE_CROP_TOOL_PROPS:
      return {
        ...state,
        cropToolProps: action.props,
      };
    case UPDATE_IMAGE_PROPS:
      return {
        ...state,
        imageProps: action.props,
      };
    case UPDATE_CROP_SCALE:
      return {
        ...state,
        cropScale: action.value,
      };
    case CANCEL_IMAGE_PREVIEW:
      return {
        ...state,
        cropping: action.wasCropping,
        imageCrop: DEFAULT_IMAGE_CROP,
        previewing: false,
        wasCropping: false,
      };
    case SAVE_IMAGE:
      return {
        ...state,
        previewing: false,
        saving: true,
      };
    case SAVE_IMAGE_SUCCESS:
      return {
        ...state,
        brightness: DEFAULT_BRIGHTNESS,
        imageCrop: DEFAULT_IMAGE_CROP,
        saving: false,
      };
    case VIEW_IMAGE_PREVIEW:
      return {
        ...state,
        cropping: false,
        wasCropping: state.cropping,
      };
    case UPDATE_KEEP_ASPECT_RATIO:
      return {
        ...state,
        keepAspectRatio: action.value,
      };
    default:
      return state;
  }
};

export default reducer;
